
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonReportChart from '@/components/common/CommonReportChart.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import { getOldInterface } from '@/apis/index';
import { formatTime, jumpReport, jumpTimeShare, pushBy2804, checkLogin } from '@/utils/tools';
import { FUTURES_REPORT_TYPE } from '@/config/config';

@Component({
  components: {
    CommonBlockLine,
    CommonReportChart,
    CommonRankNumber,
  },
})
export default class ReportCard extends Vue {
  @Prop() private item!: any;
  @Prop() private config!: any;
  @Prop() private readNum!: number;
  @Prop() private isFirst!: boolean;
  @Prop() private chart!: boolean;
  @Prop() private isDeep!: boolean;
  @Prop() private stat!: string;
  // 是否展示关注
  isShowFollow = false;
  // 目标价
  risingUp = '';
  get stockInfo() {
    const { pid, stockName, stockCode, orgName, orgId, author, authorId, market } = this.item as any;
    return {
      stockName,
      stockCode,
      orgName,
      orgId,
      author,
      authorId,
      market,
      pid,
    };
  }
  get stockList() {
    const nameList = this.item.stockName.split('!');
    return this.item.stockCode
      .split('!')
      .map((code, index) => ({
        code,
        name: nameList[index],
      }))
      .slice(0, 2);
  }
  get isVip() {
    const { author, newWealthInfo, orgName } = this.item as any;
    if (orgName === '投研BBC') {
      return true;
    }
    return newWealthInfo && newWealthInfo.length && !this.config.isOrg && author;
  }
  get isShowDeep() {
    return this.isDeep || this.item.cat.includes('深度');
  }
  get firstName() {
    const { author, orgName } = this.item as any;
    if (this.config.isOrg) {
      return orgName;
    } else {
      return author ? author : orgName;
    }
  }
  get newWealthTag() {
    if (this.isVip) {
      const { newWealthInfo, orgName } = this.item as any;
      const tag = newWealthInfo && newWealthInfo.length ? newWealthInfo[0] : '';
      return orgName === '投研BBC' ? '同花顺iFinD官方账号' : tag;
    } else {
      return '';
    }
  }
  get catTag() {
    // cat标签
    const { cat } = this.item;
    if (cat) {
      // 存在!只取前面部分
      return cat.split('!')[0];
    } else {
      return '';
    }
  }
  get isShowCat() {
    // 是否展示cat标签 展示图表的时候展示 或者 不展示图表并且没有深度研报的时候
    return this.catTag && (this.chart || (!this.chart && !this.isShowDeep));
  }
  get rating() {
    const colorArr = [
      { name: '买入', color: '#ff2436' },
      { name: '增持', color: '#FF661A' },
      { name: '中性', color: '#FF9500' },
      { name: '减持', color: '#39BC6F' },
      { name: '卖出', color: '#07AB4B' },
    ];
    return colorArr.find(item => item.name === this.item.rating);
  }
  get isFollow() {
    const { authorId, orgId } = this.item as any;
    if (this.config.isOrg) {
      return this.$followOrgList[orgId];
    } else {
      return authorId ? this.$followAuthorList[authorId] : this.$followOrgList[orgId];
    }
  }
  get isSelfMedia() {
    const { authorId, orgId } = this.item as any;
    // 区分普通渠道自媒体专栏
    return !authorId && !orgId;
  }
  get isFuturesReport() {
    const { catId } = this.item as any;
    return catId === FUTURES_REPORT_TYPE;
  }
  get canBeFollowed() {
    return !this.isSelfMedia && !this.isFuturesReport;
  }
  toMainPage(flag: string) {
    if (!this.canBeFollowed) {
      return;
    }
    let type = '';
    if (this.config.isOrg) {
      type = flag ? 'orgId' : 'authorId';
    } else {
      if (flag) {
        type = this.item.author ? 'authorId' : 'orgId';
      } else {
        type = 'orgId';
      }
    }
    const { orgName, author } = this.item;
    let temp = {};
    if (type === 'orgId') {
      temp = {
        name: orgName,
      };
    } else {
      temp = {
        name: author,
        org: orgName,
      };
    }
    // 圈复杂度超过15 抽出埋点方法
    this.handleToMainPageStat(this.stat, type);
    temp[type] = this.item[type];
    this.jumpToMain(type, temp);
  }
  handleToMainPageStat(stat, type) {
    if (stat) {
      // 增加作者/机构信息的埋点
      const typeStat = type === 'orgId' ? 'jgzy' : 'fxszy';
      window.hxmClickStat(`${this.stat}.${typeStat}`);
    }
  }
  jumpToMain(type, temp) {
    // 跳转拦截
    if (!temp[type]) {
      return;
    }
    pushBy2804('/mainPage', temp);
  }
  formatName(name: string) {
    const first = name.substr(0, 1);
    return first;
  }
  toFenshi(code: string) {
    // 跳转埋点
    window.hxmClickStat(`${this.stat}.ggfs`);
    // 跳转分时
    const { stockCode, market } = this.item;
    // 多条股票代码的情况
    jumpTimeShare({
      stockCode: stockCode.includes('!') ? code : stockCode,
      market,
    });
  }
  toReport(stat: string) {
    // 增加跳转到研报的埋点
    this.stat && window.hxmClickStat(`${this.stat}.${stat}`);
    // 跳转研报
    this.item.pid && jumpReport(this.item.pid, this.isSelfMedia);
  }
  formatTime(time: string) {
    // 格式化时间 当前时间
    const now = new Date();
    // 发布的时间
    const publish = new Date(time.replace(new RegExp(/-/gm), '/'));
    const obj = {
      '-86400000': '昨日',
      '0': '今日',
    };
    // 格式化时间
    let format = formatTime(publish, 'yyyy-MM-dd');
    // 获取MM-dd | yyyy-MM-dd
    format = format.slice(0, 4) === `${now.getFullYear()}` ? format.slice(5) : format;
    // 最终的时间 今日 | 昨日 |
    return obj[publish.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)] || format;
  }
  formatRead(num: number) {
    if (num < 10000 && num >= 1) {
      return num;
    } else if (num < 100000000 && num >= 10000) {
      const divide = (Number(num) / 10000).toFixed(1);
      return `${divide}万`;
    } else if (num >= 100000000) {
      const divide = (Number(num) / 100000000).toFixed(1);
      return `${divide}亿`;
    } else {
      return 0;
    }
  }
  handleFollow() {
    checkLogin(this.orgFollow, () => {
      this.$syncFollow();
    });
  }
  orgFollow() {
    let type = '';
    if (!this.config.isOrg && this.item.author) {
      type = 'authorId';
    } else {
      type = 'orgId';
    }
    getOldInterface({
      act: 'follow',
      con: 'user',
      type: type === 'orgId' ? '2' : '3',
      status: this.isFollow === 2 ? -1 : 1,
      followId: this.item[type],
    }).then(res => {
      if (res.statusCode === 0) {
        // 关注和取消关注的埋点
        const stat = this.isFollow === 2 ? 'jianguanzhu' : 'guanzhu';
        this.stat && window.hxmClickStat(`${this.stat}.${stat}`);
        this.isShowFollow = true;
        this.$emit('followClick', this.item[type], this.isFollow !== 2, type);
      }
      if (res.statusCode === 300) {
        this.$toast('用户未登录');
      }
    });
  }
  created() {
    // 初始化是否展示关注
    this.isShowFollow = !this.isFollow;
    const { risingUp } = this.item;
    // 目标价获取
    if (risingUp) {
      this.risingUp = (risingUp / 100).toFixed(2);
    }
  }
}
